import './basic-archive-card.scss'

import { defineComponent, PropType } from 'vue';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

import { ArchiveResource, TranslatedString } from '@skinsoft/types';
import { archiveSelectors, thesaurusTermSelectors } from '@skinsoft/selectors';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { BASIC_ARCHIVE_CARD_TITLE_CLICKED } from '../../../events';
import { LocalizedString, Touchable } from '@skinsoft/ui';
import { Media } from '@skinsoft/ui/src/item-card/media';

interface DesactivatedFields {
    title?: boolean,
    descriptionLevel?: boolean,
    cote?: boolean,
}

export const BasicArchiveCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMedia: Media,
        sLocalizedString: LocalizedString,
        sTouchable: Touchable,
    },
    props: {
        archive: {
            type: Object as PropType<ArchiveResource>,
            required: true,
        },
        excludedFields: {
            type: Object as PropType<DesactivatedFields>,
        },
        actionsAvailable: {
            type: Boolean,
            default: false,
        },
        clickableTitle: {
            type: Boolean,
            default: false,
        }
    },
    template: require('./basic-archive-card.html'),
    data() {
        return {
            descriptionLevel: null as TranslatedString | undefined | null,
            titleClickIcon: faExternalLinkAlt,
        }
    },
    computed: {
        cote(): string {
            return archiveSelectors.cote(this.archive) ?? ""
        },
        title(): string {
            return archiveSelectors.title(this.archive, this.getAppLocale()) ?? ''
        },
        mediaId(): string {
            return archiveSelectors.firstMediaId(this.archive) ?? ""
        },
        showTitle(): boolean {
            return (this.excludedFields?.title) !== true
        },
        showDescriptionLevel(): boolean {
            return (this.excludedFields?.descriptionLevel) !== true
        },
        showCote(): boolean {
            return (this.excludedFields?.cote) !== true
        },
    },
    methods: {
        onTitleClicked() {
            if(this.clickableTitle) {
                this.$emit(BASIC_ARCHIVE_CARD_TITLE_CLICKED)
            } else {
                this.$emit('click')
            }
        },
        async updateDescriptionLevel() {
            if(this.showDescriptionLevel) {
                this.descriptionLevel = null
                const thesaurusTermId = archiveSelectors.descriptionLevel(this.archive)
                if(thesaurusTermId) {
                    const thesaurusTerm = await this.$thesaurusTermDataStore.fetchOne(thesaurusTermId).toPromise()
                    if(thesaurusTerm) {
                        this.descriptionLevel = thesaurusTermSelectors.preferredTerm(thesaurusTerm)
                    }
                }
            }
        },
    },
    watch: {
        archive() {
            this.updateDescriptionLevel()
        },
    },
    mounted() {
        this.updateDescriptionLevel()
    },
})
